export const GOOGLE_STORE_URL =
  "https://play.google.com/store/apps/details?id=etoba.radio&hl=en_US&gl=US";
export const APPLE_STORE_URL =
  "https://apps.apple.com/us/app/hiko-podcast-radio-music-voice/id1565934439";
export const EMAIL = "mailto:contact@hiko.com";
